<app-header [navbarBrandRouterLink]="['/']" [fixed]="true"
    [navbarBrandFull]="{src: 'assets/images/logo/petiak.png', width: 89, height: 37, alt: 'Petiak'}"
    [navbarBrandMinimized]="{src: 'assets/images/logo/petiak-small.png', width: 30, height: 30, alt: 'Petiak'}"
    [asideMenuToggler]="false" [mobileAsideMenuToggler]="false" [sidebarToggler]="false" [mobileSidebarToggler]="false">
    <span class="float-left pr-2">{{'ADSL_ONLINE_ROUNDUP' | translate}}</span>
</app-header>

<div id="page" class="p-4">
    <form (submit)="onFormSubmit()" id="seedForm">
        <!-- <img class="d-block mx-auto" src="./assets/images/logo/petiak.png" alt="Petiak" (click)="home()"> -->
        <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{'ROUNDUP' | translate}}</div>
            <div class="dx-field">
                <div class="dx-field-label">{{'TEL_CODE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="seed.code" name="code" [disabled]="CRA_Code">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="پیش شماره اجباری می‌باشد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="pattern" pattern="\d{3}" message="فقط عدد"></dxi-validation-rule>
                            <dxi-validation-rule type="stringLength" [min]="3" [max]="3"
                                message="پیش شماره شهر باید ۳ رقم باشد"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'TEL_NO' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="seed.no" name="no">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="شماره تلفن اجباری می‌باشد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="pattern" pattern="\d{8}" message="فقط عدد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="stringLength" [min]="8" [max]="8"
                                message="شماره تلفن باید ۸ رقم باشد"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'PERSON_TYPE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-radio-group dir="ltr" [items]="['حقوقی', 'حقیقی']" layout="horizontal"
                        [(ngModel)]="seed.person_type" name="person_type">
                    </dx-radio-group>
                </div>
            </div>
            <div *ngIf="seed.person_type === 'حقیقی'" class="dx-field">
                <div class="dx-field-label">{{'NATIONAL_CODE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="seed.identification_no" name="identification_no">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="کد ملی اجباری می‌باشد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="pattern" pattern="\d{10}" message="فقط عدد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="stringLength" [min]="10" [max]="10"
                                message="کد ملی باید ۱۰ رقم باشد">
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <div *ngIf="seed.person_type === 'حقوقی'" class="dx-field">
                <div class="dx-field-label">{{'NATIONAL_IDENTIFICATION' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="seed.identification_no" name="identification_no">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="شناسه ملی اجباری می‌باشد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="pattern" pattern="\d{11}" message="فقط عدد">
                            </dxi-validation-rule>
                            <dxi-validation-rule type="stringLength" [min]="11" [max]="11"
                                message="شناسه ملی باید ۱۱ رقم باشد">
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>

        </div>
        <div #recaptcha></div>
        <div class="dx-fieldset" style="text-align: center;">
            <dx-validation-summary id="summary"></dx-validation-summary>

            <dx-button *ngIf="captchaVerified && !trying && craVerified && seed.no && seed.identification_no"
                id="button" text="{{'CONFIRM' | translate}}" type="success" [useSubmitBehavior]="true">
            </dx-button>
        </div>
    </form>

    <ngb-alert type="danger" [dismissible]="false" *ngIf="errorMsg">
        {{errorMsg | translate}}
    </ngb-alert>

    <ngb-alert type="success" [dismissible]="false" *ngIf="successMsg">
        {{successMsg | translate}}
    </ngb-alert>
</div>